export default "__VITE_ASSET__CGZhYSJY__"